// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Hero — Soft UI Design System Pro "page-header" pattern
 * (full-bleed media, bg-gradient-dark mask, curved divider), in BuzBiz gold.
 */
.hero {
  --hero-gold: #ffbc00;
  --hero-gold-deep: #e89a00;
  --hero-ink: #141727;

  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 100vh;
  padding: 8rem 0 6rem;
  overflow: hidden;
  background: var(--hero-ink);
  color: #fff;
  z-index: 1;
}

.hero .hero-video-container {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  background: var(--hero-ink);
}

.hero .hero-video,
.hero .hero-fallback-image {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.hero .hero-video {
  opacity: 0;
  transition: opacity 0.5s ease-in;
}

.hero .hero-video.ready {
  opacity: 1;
}

.hero .hero-video.error {
  display: none;
}

/* Soft UI .mask.bg-gradient-dark */
.hero .hero-mask {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);
  opacity: 0.82;
  pointer-events: none;
}

.hero .container {
  position: relative;
  z-index: 2;
  width: 100%;
}

.hero .hero-content {
  max-width: 720px;
}

/* Announcement pill */
.hero .hero-announcement {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  max-width: 100%;
  margin-bottom: 1.75rem;
  padding: 0.3rem 0.875rem 0.3rem 0.3rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  border-radius: 2rem;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.18);
  -webkit-backdrop-filter: saturate(200%) blur(30px);
  backdrop-filter: saturate(200%) blur(30px);
  transition: background-color 0.2s ease;
  animation: fadeInDown 0.8s ease-out;
}

.hero .hero-announcement:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
}

.hero .hero-announcement-badge {
  flex-shrink: 0;
  padding: 0.2rem 0.6rem;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--hero-ink);
  border-radius: 2rem;
  background-image: linear-gradient(310deg, var(--hero-gold-deep) 0%, var(--hero-gold) 100%);
}

.hero .hero-announcement-arrow {
  transition: transform 0.2s ease;
}

.hero .hero-announcement:hover .hero-announcement-arrow {
  transform: translateX(3px);
}

/* Type */
.hero .hero-title {
  margin: 0 0 1.25rem;
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.025em;
  color: #fff;
  animation: fadeInUp 0.8s ease-out 0.1s both;
}

/* Soft UI .text-gradient, gold variant */
.hero .text-gradient-gold {
  background-image: linear-gradient(310deg, var(--hero-gold-deep) 0%, #ffd34d 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero .hero-lead {
  margin: 0 0 2.5rem;
  max-width: 600px;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.82);
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

/* Form */
.hero .hero-form {
  max-width: 640px;
  animation: fadeInUp 0.8s ease-out 0.3s both;
}

.hero .challenge-label {
  display: block;
  margin-bottom: 0.625rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.7);
}

.hero .hero-input-group {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem;
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.15s ease;
}

.hero .hero-input-group:focus-within {
  box-shadow: 0 0 0 2px var(--hero-gold), 0 20px 27px 0 rgba(0, 0, 0, 0.12);
}

.hero .challenge-input {
  flex: 1;
  min-width: 0;
  padding: 0.75rem 0.875rem;
  font: inherit;
  font-size: 1rem;
  color: #344767;
  background: transparent;
  border: none;
  outline: none;
}

.hero .challenge-input::placeholder {
  color: #8392ab;
}

/* Soft UI buttons */
.hero .hero-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 1.4;
  text-decoration: none;
  white-space: nowrap;
  border-radius: 0.5rem;
  border: 1px solid transparent;
  cursor: pointer;
  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);
  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in, background-color 0.15s ease-in;
}

.hero .hero-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);
}

.hero .hero-btn-gold {
  color: var(--hero-ink);
  background-image: linear-gradient(310deg, var(--hero-gold-deep) 0%, var(--hero-gold) 100%);
}

.hero .hero-btn-gold:hover {
  color: var(--hero-ink);
}

.hero .hero-btn-outline {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.75);
  background: transparent;
  box-shadow: none;
}

.hero .hero-btn-outline:hover {
  color: var(--hero-ink);
  background: #fff;
}

.hero .hero-secondary-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.hero .hero-link {
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-color: rgba(255, 255, 255, 0.4);
  transition: text-decoration-color 0.2s ease;
}

.hero .hero-link:hover {
  color: #fff;
  text-decoration-color: var(--hero-gold);
}

.hero a:focus-visible,
.hero button:focus-visible {
  outline: 2px solid var(--hero-gold);
  outline-offset: 3px;
}

/* Curved divider into the next (white) section */
.hero .hero-curve {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 36px;
  overflow: hidden;
  z-index: 2;
  color: #fff;
}

.hero .hero-curve svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: scale(2);
  transform-origin: top center;
}

@media (prefers-reduced-motion: reduce) {
  .hero .hero-announcement,
  .hero .hero-title,
  .hero .hero-lead,
  .hero .hero-form {
    animation: none;
  }

  .hero .hero-btn,
  .hero .hero-btn:hover {
    transform: none;
    transition: none;
  }
}

@media (max-width: 768px) {
  .hero {
    min-height: 100svh;
    padding: 6.5rem 0 4.5rem;
  }

  .hero .hero-announcement {
    font-size: 0.75rem;
  }

  .hero .hero-lead {
    font-size: 1.05rem;
    margin-bottom: 2rem;
  }

  .hero .hero-input-group {
    flex-direction: column;
    align-items: stretch;
  }

  .hero .hero-input-group .hero-btn {
    width: 100%;
  }

  .hero .hero-secondary-actions {
    gap: 1rem;
  }

  .hero .hero-secondary-actions .hero-btn {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/frontpage/components/Hero.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;;EAEnB,sEAAsE;EACtE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,QAAQ;EACR,mEAAmE;EACnE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,kDAAkD;EAClD,0CAA0C;EAC1C,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,0FAA0F;AAC5F;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,2CAA2C;AAC7C;;AAEA,yCAAyC;AACzC;EACE,iFAAiF;EACjF,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,kFAAkF;EAClF,6FAA6F;AAC/F;;AAEA;EACE,sBAAsB;EACtB,mFAAmF;AACrF;;AAEA;EACE,sBAAsB;EACtB,0FAA0F;AAC5F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;EAC1B,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,uCAAuC;AACzC;;AAEA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":["/*\n * Hero — Soft UI Design System Pro \"page-header\" pattern\n * (full-bleed media, bg-gradient-dark mask, curved divider), in BuzBiz gold.\n */\n.hero {\n  --hero-gold: #ffbc00;\n  --hero-gold-deep: #e89a00;\n  --hero-ink: #141727;\n\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 100vh;\n  padding: 8rem 0 6rem;\n  overflow: hidden;\n  background: var(--hero-ink);\n  color: #fff;\n  z-index: 1;\n}\n\n.hero .hero-video-container {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  background: var(--hero-ink);\n}\n\n.hero .hero-video,\n.hero .hero-fallback-image {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n\n.hero .hero-video {\n  opacity: 0;\n  transition: opacity 0.5s ease-in;\n}\n\n.hero .hero-video.ready {\n  opacity: 1;\n}\n\n.hero .hero-video.error {\n  display: none;\n}\n\n/* Soft UI .mask.bg-gradient-dark */\n.hero .hero-mask {\n  position: absolute;\n  inset: 0;\n  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);\n  opacity: 0.82;\n  pointer-events: none;\n}\n\n.hero .container {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n}\n\n.hero .hero-content {\n  max-width: 720px;\n}\n\n/* Announcement pill */\n.hero .hero-announcement {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.625rem;\n  max-width: 100%;\n  margin-bottom: 1.75rem;\n  padding: 0.3rem 0.875rem 0.3rem 0.3rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #fff;\n  text-decoration: none;\n  border-radius: 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.18);\n  -webkit-backdrop-filter: saturate(200%) blur(30px);\n  backdrop-filter: saturate(200%) blur(30px);\n  transition: background-color 0.2s ease;\n  animation: fadeInDown 0.8s ease-out;\n}\n\n.hero .hero-announcement:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.hero .hero-announcement-badge {\n  flex-shrink: 0;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--hero-ink);\n  border-radius: 2rem;\n  background-image: linear-gradient(310deg, var(--hero-gold-deep) 0%, var(--hero-gold) 100%);\n}\n\n.hero .hero-announcement-arrow {\n  transition: transform 0.2s ease;\n}\n\n.hero .hero-announcement:hover .hero-announcement-arrow {\n  transform: translateX(3px);\n}\n\n/* Type */\n.hero .hero-title {\n  margin: 0 0 1.25rem;\n  font-size: clamp(2.5rem, 6vw, 4rem);\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.025em;\n  color: #fff;\n  animation: fadeInUp 0.8s ease-out 0.1s both;\n}\n\n/* Soft UI .text-gradient, gold variant */\n.hero .text-gradient-gold {\n  background-image: linear-gradient(310deg, var(--hero-gold-deep) 0%, #ffd34d 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.hero .hero-lead {\n  margin: 0 0 2.5rem;\n  max-width: 600px;\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 1.65;\n  color: rgba(255, 255, 255, 0.82);\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n/* Form */\n.hero .hero-form {\n  max-width: 640px;\n  animation: fadeInUp 0.8s ease-out 0.3s both;\n}\n\n.hero .challenge-label {\n  display: block;\n  margin-bottom: 0.625rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.hero .hero-input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem;\n  background: #fff;\n  border-radius: 0.75rem;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.12);\n  transition: box-shadow 0.15s ease;\n}\n\n.hero .hero-input-group:focus-within {\n  box-shadow: 0 0 0 2px var(--hero-gold), 0 20px 27px 0 rgba(0, 0, 0, 0.12);\n}\n\n.hero .challenge-input {\n  flex: 1;\n  min-width: 0;\n  padding: 0.75rem 0.875rem;\n  font: inherit;\n  font-size: 1rem;\n  color: #344767;\n  background: transparent;\n  border: none;\n  outline: none;\n}\n\n.hero .challenge-input::placeholder {\n  color: #8392ab;\n}\n\n/* Soft UI buttons */\n.hero .hero-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.875rem 1.75rem;\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  line-height: 1.4;\n  text-decoration: none;\n  white-space: nowrap;\n  border-radius: 0.5rem;\n  border: 1px solid transparent;\n  cursor: pointer;\n  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);\n  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in, background-color 0.15s ease-in;\n}\n\n.hero .hero-btn:hover {\n  transform: scale(1.02);\n  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);\n}\n\n.hero .hero-btn-gold {\n  color: var(--hero-ink);\n  background-image: linear-gradient(310deg, var(--hero-gold-deep) 0%, var(--hero-gold) 100%);\n}\n\n.hero .hero-btn-gold:hover {\n  color: var(--hero-ink);\n}\n\n.hero .hero-btn-outline {\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.75);\n  background: transparent;\n  box-shadow: none;\n}\n\n.hero .hero-btn-outline:hover {\n  color: var(--hero-ink);\n  background: #fff;\n}\n\n.hero .hero-secondary-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.hero .hero-link {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  text-decoration-color: rgba(255, 255, 255, 0.4);\n  transition: text-decoration-color 0.2s ease;\n}\n\n.hero .hero-link:hover {\n  color: #fff;\n  text-decoration-color: var(--hero-gold);\n}\n\n.hero a:focus-visible,\n.hero button:focus-visible {\n  outline: 2px solid var(--hero-gold);\n  outline-offset: 3px;\n}\n\n/* Curved divider into the next (white) section */\n.hero .hero-curve {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 36px;\n  overflow: hidden;\n  z-index: 2;\n  color: #fff;\n}\n\n.hero .hero-curve svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(2);\n  transform-origin: top center;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .hero .hero-announcement,\n  .hero .hero-title,\n  .hero .hero-lead,\n  .hero .hero-form {\n    animation: none;\n  }\n\n  .hero .hero-btn,\n  .hero .hero-btn:hover {\n    transform: none;\n    transition: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    min-height: 100svh;\n    padding: 6.5rem 0 4.5rem;\n  }\n\n  .hero .hero-announcement {\n    font-size: 0.75rem;\n  }\n\n  .hero .hero-lead {\n    font-size: 1.05rem;\n    margin-bottom: 2rem;\n  }\n\n  .hero .hero-input-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .hero .hero-input-group .hero-btn {\n    width: 100%;\n  }\n\n  .hero .hero-secondary-actions {\n    gap: 1rem;\n  }\n\n  .hero .hero-secondary-actions .hero-btn {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
